import * as userApi from "../api/userApi";
import crypto from 'crypto';
import axios from 'axios';
import {Base64} from 'js-base64';

export const entrySys = async function (sys, classId) {
  if (localStorage.getItem('Authorization')) {
    return userApi.isExpired(localStorage.getItem('Authorization')).then(rs => {
      if (rs.code == 0 && rs.data == 0) {
        let jumpObj = getJumpInfo(sys, classId)
        if (sys === 'sj') {
          return zljtLogin(jumpObj).then((rs) => {
            if (rs.status === 200 && rs.data.code === 0) {
              let host = process.env.XSJ_API
              let jumpStr = `token=${rs.data.data.access_token}&gxzxToken=${jumpObj.token}`
              let Base64url = `${Base64.encode(jumpStr)}`
              let jumpUrl = `${host}?${Base64url}`
              return {jumpUrl}

            } else {
              return {jumpUrl: ''}
            }
          })
        }
      }
    }).catch(err => {
      console.log(err)
    })
  }
}

function getJumpInfo(sys, classId) { // 跳转所用参数集合
  let userId = sessionStorage.getItem('userId')
  // let productFlag = sessionStorage.getItem("productFlag"); // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务
  let courseId = userId + "8888"
  let qstId = '0'
  let identity = sys + 'zh'
  let encrypted = `TEACH_${courseId}_${classId}_1_0`
  /*
    encrypted拼接规则: (示例: TEACH_123_999_2_200_001)
    系统: （教学: TEACH）、（考试: EXAMS）、（大赛: MATCH）
    123: (教学: courseId)、（考试: NONE）、（大赛: NONE）
    999: (教学: classId)、（考试: examPlanId）、（大赛: examPlanId）
    2: (单项: 1)、（实训: 2）
    200: (单项: NONE)、（实训: teamId）
    001: templateCode
  */

  let obj = {
    token: localStorage.getItem('Authorization'),
    courseId: courseId,// 课程id
    classId: classId,// 班级id
    qstId: qstId,//试题id
    schoolId: sessionStorage.getItem("deptId"),// 机构id
    orgName: sessionStorage.getItem("schoolName"),// 机构名称
    username: sessionStorage.getItem("userName"),// 账号
    userId: userId,// 用户id
    nickname: sessionStorage.getItem("loginName"),// 用户姓名
    userType: sessionStorage.getItem("userType"),// 用户类型
    mobile: sessionStorage.getItem("mobile"),// 手机号
    sex: sessionStorage.getItem("sex"),// 性别
    headImgUrl: "",// 头像
    idCard: "",// 身份证
    password: 'e10adc3949ba59abbe56e057f20f883e',
    // item: ${questionDto.questionCode},
    item: '27011201-6fe9-46b4-ba7f-fe241aed2132',// questionCode
    identity: identity,
    encrypted: encrypted,
    clientId: '1349883712819109890',
    timestamp: new Date().getTime(),
    roleCodes: "3001",
    templateCode: ""
  }
  return obj
}

// 中联集团登录
async function zljtLogin(jumpObj) {
  // 加密参数
  let shanStr = `{clientId=${jumpObj.clientId}, encrypted=${jumpObj.encrypted}, identity=${jumpObj.identity}, item=${jumpObj.item}, qstId=${jumpObj.qstId}, roleCode=${jumpObj.roleCodes}, templateCode=${jumpObj.templateCode}, timeStamp=${jumpObj.timestamp}, token=${jumpObj.token}, userType=${jumpObj.userType}, username=${jumpObj.username}}`;
  let secretKey = setSha1(shanStr, '02424D4FD04A007E453DADA28E4EEE37')
  let params = {
    clientId: jumpObj.clientId,
    encrypted: jumpObj.encrypted,
    identity: jumpObj.identity,
    item: jumpObj.item,
    qstId: jumpObj.qstId,
    roleCode: jumpObj.roleCodes,
    sign: secretKey,
    templateCode: jumpObj.templateCode,
    timeStamp: jumpObj.timestamp,
    token: jumpObj.token,
    userId: jumpObj.userId,
    userType: jumpObj.userType,
    username: jumpObj.username,
  }
  let src = `${process.env.ZLJT_API}/api-oauth/v1/oauth/v2/oauth/token`
  return axios.post(src, params).then(rs => {
    return rs
  }).catch(err => {
    return err
  })
}


function setSha1(url, secretKey) {// 加密
  let hmac = crypto.createHmac('sha1', secretKey || '123456');
  hmac.update(url);
  return hmac.digest('hex');
}



// WEBPACK FOOTER //
// ./src/utils/systemJump.js